import withHeader from "hocs/withHeader";
import Head from "next/head";
import React from "react";
import dynamic from "next/dynamic";
import {ChallengeSearcherTranslation} from "../../../app__Legacy/i18n/containers/Searcher/ChallengeSearcher/typing";
import {ChallengeSearcherTexts} from "../../../app__Legacy/i18n/containers/Searcher/ChallengeSearcher";
import {getCurrentLocale, useLocales} from "@libs";
import {
	FilterSearcherItemProps,
	FilterSearcherItemType
} from "../../../app__Legacy/components/Searcher/FilterSearcher/typing";
import {BusinessProfileTypes} from "../../../app__Legacy/constants/Profiles";
import {ChallengeType} from "../../../app__Legacy/models/challenges/Challenge";

const DynamicComponent = dynamic(() => import("containers/Searcher/Challenges"));

const ChallengesPage = () => {
	const { currentShortLocale } = useLocales();
	const challengeTranslation: ChallengeSearcherTranslation = {
		...ChallengeSearcherTexts[currentShortLocale],
	};
	const { currentLocalePath } = getCurrentLocale();
	const checkMyInvitationsButton: FilterSearcherItemProps[] = [
		{
			title: challengeTranslation.seeOnlyMyInvitationsToChallenges,
			value: {
				anchorProps: {
					href: `${currentLocalePath}/searcher/challenges/invitations`,
					target: "__blank",
					className: "margin-1-bottom",
				},
				label: challengeTranslation.seeOnlyMyInvitationsToChallenges,
				color: "orange",
			},
			type: FilterSearcherItemType.BUTTON_LINK,
		},
	];
	const checkboxChallengesOriginTypes: FilterSearcherItemProps[] = [
		{
			title: challengeTranslation.challengesCreatedBy,
			value: [
				{
					text: challengeTranslation.universities,
					value: String(BusinessProfileTypes.UNIVERSITY),
				},
				{
					text: challengeTranslation.institutions,
					value: String(BusinessProfileTypes.INSTITUTION),
				},
				{
					text: challengeTranslation.incubators,
					value: String(BusinessProfileTypes.INCUBATOR),
				},
				{
					text: challengeTranslation.accelerators,
					value: String(BusinessProfileTypes.ACCELERATOR),
				},
			],
			selection: true,
			type: FilterSearcherItemType.SELECT,
		},
	];
	const checkboxChallengesTypes: FilterSearcherItemProps[] = [
		{
			title: challengeTranslation.product,
			value: {
				text: challengeTranslation.product,
				value: String(ChallengeType.PRODUCT),
			},
			type: FilterSearcherItemType.CHECKBOX,
		},
		{
			title: challengeTranslation.service,
			value: {
				text: challengeTranslation.service,
				value: String(ChallengeType.SERVICE),
			},
			type: FilterSearcherItemType.CHECKBOX,
		},
	];

	return (
		<>
			<Head>
				<title> Vinglet - Challenges </title>
			</Head>
			<DynamicComponent
				checkMyInvitationsButton={checkMyInvitationsButton}
				checkboxChallengesOriginTypes={checkboxChallengesOriginTypes}
				checkboxChallengesTypes={checkboxChallengesTypes}
				challengeTranslation={challengeTranslation}
			/>
		</>
	);
};

export default withHeader(ChallengesPage);
